import _ from "lodash";
import React, { Component } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { connect } from "react-redux";
import * as actions from "../actions";

class About extends Component {
  render() {
    const { auth } = this.props;

    // const { projects } = this.props;

    // /**
    //  * Selecting a random property from projects
    //  * Use project hero to display as backdrop
    //  * @param {*} obj
    //  */
    // var randomProperty = (obj) => {
    //     var keys = Object.keys(obj)
    //     return obj[keys[ keys.length * Math.random() << 0]];
    // };

    const style = {
      imageHero: {
        backgroundImage: `url("/images/tikki-background.jpg")`,
        // backgroundImage: `url(${randomProperty(projects).imageHero})`,
        backgroundPosition: "center center no-repeat",
        backgroundSize: "cover",
        minHeight: 450,
        maxHeight: 450
      }
    };

    return (
      <div className="about-container">
        <Header auth={auth} />
        <div style={style.imageHero} />
        <div className="about-main tikki-shadow">
          <div className="about-title tikki-title">
            <h3>ABOUT</h3>
          </div>
          <div className="about-section tikki-paragraph-bold">
            <span>
              Your chosen organisation receives 100 per cent of the donation.
            </span>
          </div>
          <div className="about-section tikki-paragraph">
            <span>
              Unlike many other giving platforms, Tikki is non-profit, entirely
              created and staffed by volunteers. This means we don’t take a cent
              of your donation - it all goes directly to the non-profit of your
              choice. Tikki has been designed together with non-profits and
              donors, so it is user friendly and easy for non-profits to take
              part in. Tikki is all about impact and transparency. You get to
              choose the project you want to support, in any country. You can
              then track your project’s progress online.
            </span>
          </div>
          <div className="about-section tikki-paragraph-bold">
            <span>
              This means you know exactly what you are funding and how your
              contribution is helping to improve people’s lives and make a
              difference.
            </span>
          </div>
          <div className="about-section tikki-paragraph">
            <span>
              Through Tikki, donors will feel engaged and close to the projects
              as they receive stories and updates on progress. We believe this
              transparent, easy to use digital technology is the best way to
              bring donors and non-profits together for the biggest impact.
            </span>
          </div>
          <div className="about-title tikki-title">
            <h3>WHO WE ARE</h3>
          </div>
          <div className="about-section tikki-paragraph">
            <span>
              Our team is passionate about the effectiveness of non-profits, and
              many of us have been on charity boards or spent many years working
              for non-profits. We are all volunteering our time with Tikki,
              because we believe that this transparent, easy-to-use digital
              technology is the best way to bring donors and non-profits
              together for the biggest impact.
            </span>
          </div>
          <div className="about-title tikki-title">
            <h3>THE FOUNDING TEAM</h3>
          </div>
          <div className="about-team tikki-paragraph">
            <div className="about-team-avatar">
              <img
                className="tikki-team-avatar responsive-img"
                src={"/images/Isi.jpg"}
                alt={"The Chief Visionary"}
              />
              <div className="tikki-team-container">
                <span className="tikki-team-name">Isabel Coppa</span>
                <br />
                <span className="tikki-team-title">Public Officer</span>
              </div>
            </div>
            <div className="about-team-avatar">
              <img
                className="tikki-team-avatar responsive-img"
                src={"/images/Chris.jpg"}
                alt={"The Chief Geek"}
              />
              <div className="tikki-team-container">
                <span className="tikki-team-name">Chris Trewin</span>
                <br />
                <span className="tikki-team-title">
                  Chief Technology Officer
                </span>
              </div>
            </div>
            <div className="about-team-avatar">
              <img
                className="tikki-team-avatar responsive-img"
                src={"/images/Nathan.jpg"}
                alt={"The Navigator"}
              />
              <div className="tikki-team-container">
                <span className="tikki-team-name">Nathan Quadros</span>
                <br />
                <span className="tikki-team-title">Head of Strategy</span>
              </div>
            </div>
            <div className="about-team-avatar">
              <img
                className="tikki-team-avatar responsive-img"
                src={"/images/Phi.jpg"}
                alt={"The Experience Expert"}
              />
              <div className="tikki-team-container">
                <span className="tikki-team-name">Phi Do</span>
                <br />
                <span className="tikki-team-title">
                  Head of Creative & UX Design
                </span>
              </div>
            </div>
            <div className="about-team-avatar">
              <img
                className="tikki-team-avatar responsive-img"
                src={"/images/Serina.jpg"}
                alt={"The Professional Hustler"}
              />
              <div className="tikki-team-container">
                <span className="tikki-team-name">Serina Gill</span>
                <br />
                <span className="tikki-team-title">
                  Head of Security & Operations
                </span>
              </div>
            </div>
            <div className="about-team-avatar">
              <img
                className="tikki-team-avatar responsive-img"
                src={"/images/Thanh.jpg"}
                alt={"The Geek Queen"}
              />
              <div className="tikki-team-container">
                <span className="tikki-team-name">Thanh Nguyen</span>
                <br />
                <span className="tikki-team-title">
                  Head of Architecture & Development
                </span>
              </div>
            </div>
            <div className="about-team-avatar">
              <img
                className="tikki-team-avatar responsive-img"
                src={"/images/Tahli.jpg"}
                alt={"The Graphics Genie"}
              />
              <div className="tikki-team-container">
                <span className="tikki-team-name">Tahli Mastores</span>
                <br />
                <span className="tikki-team-title">Designer</span>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps({ screens, projects }) {
  return { screens, projects };
}

export default connect(
  mapStateToProps,
  actions
)(About);



// WEBPACK FOOTER //
// ./src/pages/AboutPage.js